import * as React from 'react';
import {Button, Modal} from 'antd';
import locales from '../locales';
import ButtonBar from '../common/ButtonBar';
import {VisibilityProperty} from 'csstype';
import SetTransferredForm from './SetTransferredForm';
import ToBeTransferredExportForm from './ToBeTransferredExportForm';

interface Props {
  showStateActionButtons: boolean;
  onCreateInvoiceClicked: () => void;
  onMarkAsToBeTransferred: () => void;
  onMarkAsTransferred: (paidDate: string) => void;
  onExportToBeTransferredItem: (name: string) => void;
}

interface State {
  showTransferredDateSelectModal: boolean;
  showExcelNameInputModal: boolean;
}

class IncomingInvoiceActions extends React.Component<Props, State> {
  public state: State = {
    showTransferredDateSelectModal: false,
    showExcelNameInputModal: false,
  };

  public render() {
    const {
      showStateActionButtons,
      onCreateInvoiceClicked,
      onMarkAsToBeTransferred
    } = this.props;
    const {showTransferredDateSelectModal, showExcelNameInputModal} = this.state;
    const actionButtonVisibility: VisibilityProperty = showStateActionButtons ? 'visible' : 'hidden';
    return (
      <>
        <Modal
          title={locales.set_transferred_date}
          visible={showTransferredDateSelectModal}
          footer={null}
          onCancel={this.hideTransferredDateSelectModal}
          destroyOnClose={true}
        >
          <SetTransferredForm
            onFormCancel={this.hideTransferredDateSelectModal}
            onFormSubmit={this.onSetTransferred}
          />
        </Modal>
        <Modal
          title={locales.export_to_be_transferred_items}
          visible={showExcelNameInputModal}
          footer={null}
          onCancel={this.hideExcelNameInputModal}
          destroyOnClose={true}
        >
          <ToBeTransferredExportForm
            onFormCancel={this.hideExcelNameInputModal}
            onFormSubmit={this.onExcelNameEntered}
          />
        </Modal>
        <ButtonBar style={{marginBottom: 8}}>
          <Button
            size="small"
            icon="credit-card"
            style={{visibility: actionButtonVisibility}}
            onClick={onMarkAsToBeTransferred}>{locales.mark_to_be_transferred}</Button>
          <Button
            size="small"
            icon="check"
            onClick={this.showTransferredDateSelectModal}>{locales.mark_transferred}</Button>
          <Button
            size="small"
            icon="export"
            onClick={this.showExcelNameInputModal}>{locales.export_to_be_transferred_items}</Button>
          <Button
            size="small"
            type="primary"
            icon="plus"
            onClick={onCreateInvoiceClicked}>{locales.add}</Button>
        </ButtonBar>
      </>
    );
  }

  private showExcelNameInputModal = () => {
    this.setState({showExcelNameInputModal: true})
  };

  private hideExcelNameInputModal = () => {
    this.setState({showExcelNameInputModal: false})
  };

  private showTransferredDateSelectModal = () => {
    this.setState({showTransferredDateSelectModal: true})
  };

  private hideTransferredDateSelectModal = () => {
    this.setState({showTransferredDateSelectModal: false})
  };

  private onSetTransferred = (paidDate: string) => {
    this.hideTransferredDateSelectModal();
    this.props.onMarkAsTransferred(paidDate);
  };

  private onExcelNameEntered = (name: string) => {
    this.hideExcelNameInputModal();
    this.props.onExportToBeTransferredItem(name);
  }
}

export default IncomingInvoiceActions;


// WEBPACK FOOTER //
// ./src/incoming-invoices/IncomingInvoiceActions.tsx